import React, { RefObject, useEffect } from "react";
import "./style.scss";
import { ReactComponent as ShiftIcon } from "../../assets/icons/shift.svg";
import { ReactComponent as BackspaceIcon } from "../../assets/icons/backspace.svg";

export interface NumKeyboardProps {
    text: string;
    clearRef?: RefObject<any>;
    onChangeText: (text: string) => void;
}

const keys = [
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "backspace"]
];

const NumKeyboard = ({text, clearRef, onChangeText}: NumKeyboardProps) => {

    useEffect(() => {
        let clear = clearRef?.current;

        if (clear) {
            clear.addEventListener("click", onClearClick);
        }

        return () => {
            if (clear)
                clear.removeEventListener("click", onClearClick);
        }

    }, [clearRef]);

    const onClearClick = () => {
        onChangeText("");
    }

    const getButtonValue = (key: string): string | React.JSX.Element => {
        let r: string | React.JSX.Element = key;

        switch(key) {
            case "shift":
                r = <ShiftIcon className="shift" />
                break;
            case "backspace":
                r = <BackspaceIcon className="backspace" />
                break;
        }

        return r;
    }

    const pressKey = (key: string) => {
        switch(key) {
            case "backspace":
                onChangeText(text.substring(0, text.length - 1));
                break;
            default:
                onChangeText(text + key);
        }
    }

    return <div className="Keyboard">
        {keys.map((row, i) => <div key={`row_${i}`} className="row">
            {row.map(x => <div
                            key={`key_${x}`}
                            className={`key ${x === "shift" || x === "backspace" ? "dark" : ""}`}
                            onClick={() => pressKey(x)}
                            >
                                {getButtonValue(x)}
                            </div>
            )}
        </div>)}
    </div>
}

export default NumKeyboard;
